import { RADIO, CHECKBOX } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import { REMOTE_TRUE } from 'src/containers/AddSkuPage/constants';

import { BRANDS, BRAND_TYPES } from 'src/containers/AddSkuPage/QuestionsFlowPage/skudata/constants';
import { getOverridesByRemoteSelectionWithProblem } from './utils';

export const OVERRIDES_BY_REMOTE = {
  3861: {
    hint:
      "This issue cannot be addressed remotely, we'll switch your service to In-Home, base price will be adjusted.",
  },
  3860: {
    hint:
      "This issue cannot be addressed remotely, we'll switch your service to In-Home, base price will be adjusted.",
  },
};

export const OVERRIDES_BY_REMOTE_DEFAULT = {
  3861: { label: 'Makes loud noises (+$30)', value: 30 },
  3860: { label: 'Starts, but crashes or freezes right away (+$30)', value: 30 },
};

/**
 *  OUR DECISION is fairly base. We seperated it out in answers and the decisionTree.
 *  Our decision tree will merge answer behaviors w/ the answer proper. Any overrides will happen in
 *  the decision tree.
 *  1. Add any 'new' answers
 *     i. if same answer id's have different values, that is ok, the tree will handle the override in the groups.
 *  2. Apply that answer to a question. What group is it part of? No seperate groups will default to group A.
 *
 */

export const answers = {
  remotetrue: {
    id: REMOTE_TRUE,
    label: 'Remote',
    hint:
      'If your computer crashes/freezes right after startup or makes loud noises, please select in-home service',
    value: -20,
  },
  remotefalse: { id: 'remote-false', label: 'In-home' },
  ...BRANDS,
  ...BRAND_TYPES(51),
  3860: {
    id: 3860,
    ...OVERRIDES_BY_REMOTE_DEFAULT[3860],
    override: getOverridesByRemoteSelectionWithProblem(3860),
  },
  3861: {
    id: 3861,
    ...OVERRIDES_BY_REMOTE_DEFAULT[3861],
    override: getOverridesByRemoteSelectionWithProblem(3861),
  },
  3862: { id: 3862, label: 'Will not recognize peripheral devices', value: 0 },
  3863: { id: 3863, label: 'Difficulty opening software/downloads', value: 0 },
  10181: { id: 10181, label: 'Other', value: 0 },
};

/**
 *  Decision Tree
 *
 *  Answers will live under 'children', slotted into a group. Default is A.
 *  Spread out the needed answers, and add:
 *  @param answerType - RADIO, CHECKBOX
 *  @param path - this is the question id the answer links to
 *  @param group - if there is a specific group within a question to link to.
 *
 *  Note: This decisionTree can have two outcomes based on remotePossinle
 */
export const decisionTree = ({ cart = {} } = {}) => {
  const baseTree = {
    brand: {
      id: 'brand',
      label: 'What brand is your computer?',
      answerType: RADIO,
      idsToStopAdvancement: ['brandOther'],
      children: {
        A: [
          { ...answers.apple, path: 'product', group: 'A' },
          { ...answers.google, path: 'product', group: 'B' },
          { ...answers.lenovo, path: 'product', group: 'C' },
          { ...answers.toshiba, path: 'product', group: 'D' },
          { ...answers.asus, path: 'product', group: 'E' },
          { ...answers.alienware, path: 'product', group: 'F' },
          { ...answers.razer, path: 'product', group: 'G' },
          { ...answers.dell, path: 'product', group: 'H' },
          { ...answers.hp, path: 'product', group: 'I' },
          { ...answers.microsoft, path: 'product', group: 'J' },
          { ...answers.acer, path: 'product', group: 'K' },
          { ...answers.sony, path: 'product', group: 'L' },
          { ...answers.huawei, path: 'product', group: 'M' },
          { ...answers.brandOther, path: 'product', group: 'N', showInput: true },
        ],
      },
    },
    product: {
      // What type
      id: 'product',
      label: 'What type of computer is it?',
      answerType: RADIO,
      children: {
        A: [
          { ...answers.desktopApple, path: '1310' },
          { ...answers.laptopApple, path: '1310' },
        ],
        B: [
          { ...answers.desktopGoogle, path: '1310' },
          { ...answers.laptopGoogle, path: '1310' },
        ],
        C: [
          { ...answers.desktopLenovo, path: '1310' },
          { ...answers.laptopLenovo, path: '1310' },
        ],
        D: [
          { ...answers.desktopToshiba, path: '1310' },
          { ...answers.laptopToshiba, path: '1310' },
        ],
        E: [
          { ...answers.desktopAsus, path: '1310' },
          { ...answers.laptopAsus, path: '1310' },
        ],
        F: [
          { ...answers.desktopAlienware, path: '1310' },
          { ...answers.laptopAlienware, path: '1310' },
        ],
        G: [
          { ...answers.desktopRazer, path: '1310' },
          { ...answers.laptopRazer, path: '1310' },
        ],
        H: [
          { ...answers.desktopDell, path: '1310' },
          { ...answers.laptopDell, path: '1310' },
        ],
        I: [
          { ...answers.desktopHP, path: '1310' },
          { ...answers.laptopHP, path: '1310' },
        ],
        J: [
          { ...answers.desktopMicrosoft, path: '1310' },
          { ...answers.laptopMicrosoft, path: '1310' },
        ],
        K: [
          { ...answers.desktopAcer, path: '1310' },
          { ...answers.laptopAcer, path: '1310' },
        ],
        L: [
          { ...answers.desktopSony, path: '1310' },
          { ...answers.laptopSony, path: '1310' },
        ],
        M: [{ ...answers.laptopHuawei, path: '1310' }],
        N: [
          { ...answers.desktop, path: '1310' },
          { ...answers.laptop, path: '1310' },
        ],
      },
    },
    1310: {
      // What's wrong with your computer
      id: 1310,
      label: "What's wrong with your computer?",
      answerType: CHECKBOX,
      complete: true,
      required: true,
      children: {
        A: [
          { ...answers[3860], path: '', complete: true },
          { ...answers[3861], path: '', complete: true },
          { ...answers[3862], path: '', complete: true },
          { ...answers[3863], path: '', complete: true },
          { ...answers[10181], path: '', complete: true },
        ],
      },
    },
  };

  if (cart.remotePossible) {
    return {
      seedQuestion: 'remote',
      maxFlow: 4,
      remote: {
        id: 'remote',
        label: 'Would you like in-home or remote service?',
        hint: 'Remote service is available.',
        answerType: RADIO,
        children: {
          A: [
            { ...answers.remotefalse, path: 'brand' },
            { ...answers.remotetrue, path: 'brand' },
          ],
        },
      },
      ...baseTree,
    };
  }

  return {
    seedQuestion: 'brand',
    maxFlow: 3,
    ...baseTree,
  };
};
